/* ## MushCore Edit ## */
class MushcoreSampleToolbar extends HTMLElement {
  constructor() {
    super();
    this.maxSamples = parseInt(this.dataset.maxSamples || '5', 10);
    this.slotsContainer = this.querySelector('[data-toolbar-slots]');
    this.messageEl = this.querySelector('[data-toolbar-message]');
    this.closeBtn = this.querySelector('[data-toolbar-close]');
    this.dismissed = false;

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.dismiss());
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => this.refresh(), 150);
      });
      subscribe(PUB_SUB_EVENTS.cartItemAdd, () => {
        this.dismissed = false;
        setTimeout(() => this.refresh(), 150);
      });
    }

    this.refresh();
  }

  dismiss() {
    this.dismissed = true;
    this.classList.remove('is-visible');
    this.classList.add('is-dismissed');
  }

  async refresh() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`);
      const cart = await response.json();
      const samples = this.getSamples(cart);
      this.render(samples);
    } catch (e) {}
  }

  getSamples(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(
      (item) => item.properties && item.properties._sample_for_product_id
    );
  }

  render(samples) {
    const count = samples.reduce((sum, item) => sum + item.quantity, 0);
    const remaining = this.maxSamples - count;
    const atLimit = count >= this.maxSamples;

    if (count > 0 && !this.dismissed) {
      this.classList.add('is-visible');
      this.classList.remove('is-dismissed');
    } else if (count === 0) {
      this.classList.remove('is-visible');
      this.dismissed = false;
    } else {
      this.classList.remove('is-visible');
    }

    if (this.messageEl) {
      if (atLimit) {
        this.messageEl.textContent = 'Maximum 5 samples reached';
      } else if (count > 0) {
        this.messageEl.textContent = `Add ${remaining} more to get ${this.maxSamples} for $${this.maxSamples}.00`;
      } else {
        this.messageEl.textContent = '';
      }
    }

    if (this.slotsContainer) {
      this.renderSlots(samples, count);
    }

    this.updateSampleButtons(atLimit);
  }

  updateSampleButtons(atLimit) {
    document.querySelectorAll('.bulk-order-sample-btn, .mushcore-sample-order-btn').forEach((btn) => {
      btn.disabled = atLimit;
      btn.classList.toggle('is-disabled', atLimit);
    });
  }

  renderSlots(samples, count) {
    let html = '';
    let slotIndex = 0;

    for (const item of samples) {
      for (let q = 0; q < item.quantity && slotIndex < this.maxSamples; q++) {
        const imageUrl = item.properties._sample_for_product_image || '';
        const title = item.properties._sample_for_product_title || '';
        html += `<div class="mushcore-sample-toolbar-slot is-filled">`;
        if (imageUrl) {
          html += `<img src="${this.escapeAttr(imageUrl)}" alt="${this.escapeAttr(title)}" width="40" height="40" loading="lazy">`;
        }
        html += `</div>`;
        slotIndex++;
      }
    }

    while (slotIndex < this.maxSamples) {
      html += `<div class="mushcore-sample-toolbar-slot is-empty"></div>`;
      slotIndex++;
    }

    this.slotsContainer.innerHTML = html;
  }

  escapeAttr(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('mushcore-sample-toolbar', MushcoreSampleToolbar);
/* ## END MushCore Edit ## */
